import React, { useCallback, useState } from "react";
import { graphql, StaticQuery } from "gatsby";
import PreviewCompatibleImage from "./PreviewCompatibleImage";

import "../styles/youtube_player.scss";
import PlayButton from "./PlayButton";
import { extractYoutubeId, buildEmbedUrl } from "../utils/youtube";

// Native iframe facade — no react-player.
// Until the user clicks play, only the thumbnail + button render (zero JS for
// YouTube). On click we mount a youtube-nocookie embed with start/end clip
// params so the user lands directly on the requested segment.

const YoutubePlayer = ({
  url = "",
  muted = false,
  loop = false,
  start = "0",
  end = "0",
  label = "",
  graph,
}) => {
  const [isPlaying, setPlaying] = useState(false);

  const play = useCallback(() => {
    setPlaying(true);
  }, []);

  const videoId = extractYoutubeId(url);
  const embedUrl = buildEmbedUrl(videoId, {
    autoplay: true,
    mute: muted,
    loop,
    start,
    end,
    controls: false,
  });

  return (
    <div className={`youtube-player`}>
      {isPlaying ? (
        <iframe
          className="react-player"
          src={embedUrl}
          width="100%"
          height="100%"
          frameBorder="0"
          loading="lazy"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={label || "YouTube video"}
        />
      ) : (
        <div className="youtube-overlay" onClick={play} title={label}>
          <PlayButton label={label} />
          {label && <div className="label">{label}</div>}
          <PreviewCompatibleImage
            imageInfo={{
              image: graph.Image,
              alt: label,
              title: label,
            }}
            styles={{
              minWidth: "350px",
              width: "100%",
              height: "100%",
              position: "absolute",
            }}
          />
        </div>
      )}
      <div className="source_label">{url}</div>
    </div>
  );
};

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        Image: allFile(
          filter: { relativePath: { regex: "/youtube_overlay.png/" } }
        ) {
          nodes {
            childImageSharp {
              gatsbyImageData(width: 500, height: 260, quality: 25, layout: CONSTRAINED, formats: [AUTO, WEBP, AVIF], placeholder: BLURRED)
            }
          }
        }
      }
    `}
    render={(data) => (
      <YoutubePlayer
        graph={{
          Image: data.Image.nodes[0],
        }}
        {...props}
      />
    )}
  />
);
